import React, { FC } from 'react';
import { Box, Typography } from '@maas-components/core';

export interface PageTitleProps {
    title: string;
    subtitle?: string | undefined;
    className?: string | undefined;
    Breadcrumb?: React.ComponentType;
}

const PageTitle: FC<PageTitleProps> = ({ title, subtitle, className, Breadcrumb }) => (
    <Box mb={2} className={className}>
        {Breadcrumb && <Breadcrumb />}
        {title && (
            <Box mt={Breadcrumb ? 1 : 0} mb={0.5} color="grey.600">
                <Typography variant="h4" component="h1">
                    {title}
                </Typography>
            </Box>
        )}
        {subtitle && (
            <Box color="grey.500">
                <Typography variant="body1" component="p">
                    {subtitle}
                </Typography>
            </Box>
        )}
    </Box>
);

export default PageTitle;
